import { useQueryClient } from '@tanstack/react-query';
import useNotifications from '../../../_lib/notifications/useNotifications';
import { queries } from '../../../queries';
import { reopenSubmission } from '../../../api/submissions/submissions.api';
import { REOPEN_FROM_LOST_REASON } from '../reopenFromLostReason';

/** Re-opens a LOST submission with the fixed reason, used by the Details header and the workspace row menu. */
export const useReopenLostSubmission = (submissionId: string) => {
  const notifications = useNotifications();
  const queryClient = useQueryClient();

  return async () => {
    try {
      await reopenSubmission(submissionId, {
        data: {
          reOpenReason: REOPEN_FROM_LOST_REASON,
          reOpenReasonDescription: REOPEN_FROM_LOST_REASON,
        },
      });
      notifications.success('Submission re-opened successfully.');
      queryClient.invalidateQueries(
        queries.submissions.details(submissionId).queryKey
      );
      queryClient.invalidateQueries(
        queries.submissions.detailsWithConfidence(submissionId).queryKey
      );
      queryClient.invalidateQueries(queries.submissions.workspace._def);
      queryClient.invalidateQueries(queries.submissions.list._def);
    } catch {
      notifications.error('Failed to re-open submission. Please try again.');
    }
  };
};
